import styled from '@emotion/styled';

import { ExternalContent, SERIF_FONT_FAMILY, Text, mq } from '@clutter/clean';

import { Location__Illustration } from '@graphql/platform';

import ILLUSTRATION_BOOK from '@root/components/landing_pages/smart_storage_v2/images/book.png';
import ILLUSTRATION_BOXES from '@root/components/landing_pages/smart_storage_v2/images/boxes.png';
import ILLUSTRATION_CLOCK from '@root/components/landing_pages/smart_storage_v2/images/clock_and_phone.png';
import ILLUSTRATION_INVENTORY from '@root/components/landing_pages/smart_storage_v2/images/phone_app.png';
import ILLUSTRATION_PIGGYBANK from '@root/components/landing_pages/smart_storage_v2/images/piggybank.png';
import ILLUSTRATION_UNIT from '@root/components/landing_pages/smart_storage_v2/images/storage_unit.png';
import ILLUSTRATION_TRUCK from '@root/components/landing_pages/smart_storage_v2/images/truck.png';

export const PAGE_HERO_CTA_LABEL = 'Get pricing';
export const PAGE_HERO_CTA_CONTAINER = 'hero';
export const PAGE_CARD_CTA_LABEL = 'Book now';
export const PAGE_CARD_CTA_CONTAINER = 'card';

export const PAGE_ILLUSTRATIONS: Record<Location__Illustration, string> = {
  [Location__Illustration.Inventory]: ILLUSTRATION_INVENTORY,
  [Location__Illustration.Unit]: ILLUSTRATION_UNIT,
  [Location__Illustration.Truck]: ILLUSTRATION_TRUCK,
  [Location__Illustration.Book]: ILLUSTRATION_BOOK,
  [Location__Illustration.Piggybank]: ILLUSTRATION_PIGGYBANK,
  [Location__Illustration.Boxes]: ILLUSTRATION_BOXES,
  [Location__Illustration.Clock]: ILLUSTRATION_CLOCK,
};

export const PageContainer = styled.main`
  margin: 0 0 48px;
`;

export const PageContent = styled.div`
  max-width: 1280px;
  width: 100%;
  ${mq({
    margin: ['24px auto', '24px auto'],
    padding: ['0 24px', '0 80px'],
  })}
`;

export const PageSectionTitle = styled.h2`
  font-family: ${SERIF_FONT_FAMILY};
  font-weight: 500;
  white-space: pre-line;
  ${mq({
    fontSize: ['32px', '40px'],
    lineHeight: ['1.2', '44px'],
  })}
`;

export const PageSectionSubtitle = styled.h3`
  font-weight: 500;
  white-space: pre-line;
  ${mq({
    fontFamily: ['"Basier Square"', SERIF_FONT_FAMILY],
    fontSize: ['18px', '28px'],
    fontWeight: [400, 500],
    lineHeight: ['120%', '40px'],
    color: ['#000', 'inherit'],
  })}
`;

export const PageSectionText = styled(Text.Body)`
  font-size: 18px;
  line-height: 1.2;
`;

export const PageExternalContent = styled(ExternalContent)`
  font-size: 18px;
  font-weight: 400;
  ${mq({
    lineHeight: ['1.4', '34px'],
  })}

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${SERIF_FONT_FAMILY};
    font-weight: 500;
    margin: 0 0 30px;
    ${mq({
      fontSize: ['32px', '40px'],
      lineHeight: ['1.2', '44px'],
    })}
  }
`;
